import { useInfiniteQuery } from "@tanstack/react-query";
import apiService from "~/services/service";
import API_ROUTES_V2 from "~/api-routes-v2";

//  React Query infinite-scroll hook for fetching a user's entity-access audit log.
//  Uses the v2 endpoint:  GET /users/{id}/audit?page={page}
//  Accepts the same signature as useTenantAudit / useTenantEntityAccessAudit so it
//  can be passed as the `useAuditHook` prop of <TenantAuditSidebar>.
export function useUserEntityAccessAudit(userId: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: ["user-entity-access-audit", userId],
    queryFn: async ({ pageParam = 1 }) => {
      const url = API_ROUTES_V2.FETCH_USER_AUDIT_ENTITY_ACCESS.replace(
        "{id}",
        userId,
      ).replace("{page}", String(pageParam));

      const response = await apiService(url, "GET", { skipCache: true });

      // Support both flat array and nested { data: [...] } shapes
      const data: unknown[] = Array.isArray(response?.data)
        ? response.data
        : (response?.data?.data ?? []);

      const pagination = response?.data?.pagination ?? {
        page: pageParam,
        totalPages: data.length > 0 ? 2 : 1, // assume more pages when data present
      };

      return {
        data,
        pagination,
        nextPage:
          (pageParam as number) < pagination.totalPages
            ? (pageParam as number) + 1
            : undefined,
      };
    },
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    enabled: enabled && !!userId,
  });
}
